import { DEFAULT_EMPTY_CELL_VALUE } from "../../../service/config";
import { YieldType } from "../../../service/globalTypes";
import { ASK_IDX, BID_IDX } from "../../../service/producerServices/constants";
import { validateYieldValue } from "../../../service/validators";
import { LAST_VALUES } from "../../constants";

const SPREAD = 20 / 100;

const isValid = (value: number) => {
  try {
    validateYieldValue(value);
    return true;
  } catch (error) {
    return false;
  }
};

interface GetSecurityYieldValueWithSpreadIfApplicableArgs {
  currentCellValue: number;
  cell: string;
  editedColumnIndex: number;
}

export const getSecurityYieldValueWithSpreadIfApplicable = ({
  currentCellValue,
  cell,
  editedColumnIndex,
}: GetSecurityYieldValueWithSpreadIfApplicableArgs) => {
  const lastValueOfCell = LAST_VALUES[cell]?.value ?? undefined;
  const currentCellValueIsValid = isValid(currentCellValue);
  const lastValueOfCellIsValid = isValid(lastValueOfCell);
  const updatedYieldInfo: { updatedValue?: number; updatedValueYieldType?: YieldType } = {};

  if (!currentCellValueIsValid && lastValueOfCell !== DEFAULT_EMPTY_CELL_VALUE && !lastValueOfCellIsValid) {
    LAST_VALUES[cell] = { value: currentCellValue };
    return {};
  }

  LAST_VALUES[cell] = { value: currentCellValue };

  if (!currentCellValueIsValid) {
    if (editedColumnIndex === ASK_IDX) {
      updatedYieldInfo.updatedValue = lastValueOfCell - SPREAD;
      updatedYieldInfo.updatedValueYieldType = YieldType.ASK;
    }

    if (editedColumnIndex === BID_IDX) {
      updatedYieldInfo.updatedValue = lastValueOfCell + SPREAD;
      updatedYieldInfo.updatedValueYieldType = YieldType.BID;
    }
  }

  if (lastValueOfCell === currentCellValue) throw new Error("Same value");

  return updatedYieldInfo;
};
